import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { api } from "../../../lib/api";
import { WikiEditor, type WikiDraft } from "../../../components/wiki/Editor";

export const Route = createFileRoute("/_authed/wiki/new")({
  component: WikiNewPage,
});

function WikiNewPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [draft, setDraft] = useState<WikiDraft>({ title: "", body_md: "", tags: [] });

  const createMut = useMutation({
    mutationFn: () => api.post<{ id: string }>("/wiki", draft),
    onSuccess: (created) => {
      qc.invalidateQueries({ queryKey: ["wiki-articles"] });
      qc.invalidateQueries({ queryKey: ["wiki-tags"] });
      navigate({ to: "/wiki/$articleId", params: { articleId: created.id } });
    },
  });

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: "24px 32px" }}>
      <div style={{ maxWidth: 860, margin: "0 auto", display: "flex", flexDirection: "column", gap: 18 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Link to="/wiki" style={{ fontSize: 13, color: "var(--ink-muted)", textDecoration: "none" }}>← Wiki</Link>
            <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Novo artigo</h1>
          </div>
          <button
            onClick={() => createMut.mutate()}
            disabled={!draft.title.trim() || createMut.isPending}
            style={{
              padding: "8px 18px", background: "var(--brand)", border: "none", borderRadius: 8,
              color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
              opacity: !draft.title.trim() || createMut.isPending ? 0.5 : 1,
            }}
          >
            {createMut.isPending ? "Publicando..." : "Publicar"}
          </button>
        </div>

        {createMut.isError && (
          <span style={{ fontSize: 12, color: "var(--danger)" }}>Falha ao publicar. Tente novamente.</span>
        )}

        <WikiEditor draft={draft} onChange={setDraft} />
      </div>
    </div>
  );
}
